"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var preact_1 = require("preact");
var render = function (component, selector, props) {
    var vNode = (0, preact_1.h)(component, props);
    (0, preact_1.render)(vNode, document.querySelector(selector));
    return vNode;
};
exports.render = render;
